import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import data from './privacy-security/dataPrivacyAndSecurity.json';
import DataSectionAccordion from './components/DataSectionAccordion'; // Adjust the path according to your file structure
import privacySecurityShield from '../../assets/img/homepage/privacy-security/shield.png';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;

`;
const Main = styled.div`
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

`;
const ContentAboveAccordion = styled.div`
  text-align: center;
  max-width: 800px; // Adjust this width as needed
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.h1`
  margin-bottom: 20px;
`;

const ShieldImage = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
  margin: 20px 0;
`;

const IntroText = styled.h3`
  font-size: 16px; // Adjust font size as needed
  line-height: 1.6; // Adjust line height for better readability
  color: #666; // Adjust color for better design
  margin-bottom: 20px; // Adds some space before the accordion starts
  text-align: left;
`;

// Main component
const DataSecurityPage = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    setSections(data.sections);
  }, []);

  return (
    <Main>
      <PageContainer>
        <ContentAboveAccordion>
          <Header>Data Privacy & Security at ClientCues</Header>
          <ShieldImage src={privacySecurityShield} alt='Privacy and Security Shield' />
          <div>
            <h2 style={{ textAlign: 'left' }}>Trust matters: ClientCues commitment to you</h2>
            <IntroText>
              At ClientCues, performance, security, and data privacy are first-order considerations, the north star for
              how we design our products and policies
              as an organization. We believe these principles need to be central to every decision we make, and
              everything
              we do as a company. That’s why we
              continue to make substantial investments in these areas to ensure that our solutions never negatively
              impact
              the integrity of your data, your users, or your application.
            </IntroText>
          </div>
        </ContentAboveAccordion>
        {sections.map((section, index) => (
          <DataSectionAccordion
            key={index}
            title={section.title}
            content={
              <>
                <p>{section.content}</p>
                {section.list && (
                  <ul>
                    {section.list.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.imageSrc && <img src={section.imageSrc} alt={section.imageAlt || 'Image'} style={{
                  width: '100%',
                  maxWidth: '600px',
                  height: 'auto',
                  display: 'block',
                  margin: '20px 0',
                }} />}
              </>
            }
          />
        ))}
      </PageContainer>
    </Main>
  );
};

export default DataSecurityPage;